<div data-pw="main-content" class="nes-mb-16">
  <router-outlet></router-outlet>
</div>
